module.exports = __webpack_public_path__ + "img/f-gplay.d82602ff.svg";